import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

/**
 * The old per-date "Mark Attendance" picker has been retired in favor of
 * the per-session flow at /class-sessions/{id}/attendance. This component
 * exists only to keep the legacy URL working: it forwards to the real
 * attendance page when an occurrence id is present, else back to the
 * Class Sessions list so the teacher can pick one.
 */
const AttendanceRecordList = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const occurrenceId = params.get("occurrenceId");
    const returnUrl = params.get("return_url");

    if (occurrenceId) {
      navigate(
        `/class-sessions/${occurrenceId}/attendance${
          returnUrl ? `?return_url=${returnUrl}` : ""
        }`,
        { replace: true }
      );
    } else {
      navigate("/attendance", { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default AttendanceRecordList;
